import React from "react";
import './Style/experiment.css'
import Marksgif from '../../../Global/assets/Science-Pie.gif'

const GraphOG = () => {
    return (
        <>
            <div className="ExperimentsB">
                <div className="CenterContent">
                    <div className="TopDiv">
                        <h2>Class-10 Science Marks</h2>
                    </div>
                    <div className="DownDiv">
                        <embed src={Marksgif} style={{
                            position: 'relative',
                            width: '100%',
                        }} type="" />
                    </div>
                    <div>
                        {/* Table */}
                    <div className="Table-Pie">
                        <table class="table" style={{color:'#ffffff', width:'100%', position:'relative'}}>
                            <thead>
                                <tr>
                                    <th scope="col">Serial No.</th>
                                    <th scope="col">Examination</th>
                                    <th scope="col">Marks Obtained</th>
                                    <th scope="col">Total Marks</th>
                                    <th scope="col">Percentage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">1.</th>
                                    <td>Peroidic - 1</td>
                                    <td>31</td>
                                    <td>40</td>
                                    <td>77.5%</td>
                                    
                                </tr>
                                <tr>
                                    <th scope="row">2.</th>
                                    <td>Half Yearly</td>
                                    <td>Null</td>
                                    <td>80</td>
                                    <td>Null</td>
                                </tr>
                                <tr>
                                    <th scope="row">3.</th>
                                    <td>Periodic - 2</td>
                                    <td>18</td>
                                    <td>20</td>
                                    <td>90.0%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { GraphOG }